import { Link } from 'react-router-dom';
import { mailtoHref, primaryNav, site } from '@/config/site';
import { Container } from '@/components/ui/Container';
import { Logo } from '@/components/layout/Logo';
import styles from './Footer.module.css';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <Container>
        <div className={styles.top}>
          <div className={styles.brand}>
            <Logo />
            <p className={styles.motto}>{site.motto}</p>
            <p className={styles.tagline}>{site.tagline}</p>
          </div>

          <nav className={styles.links} aria-label="Footer">
            <h3 className={styles.colTitle}>Explore</h3>
            <ul>
              {primaryNav.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className={styles.link}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className={styles.connect}>
            <h3 className={styles.colTitle}>Connect</h3>
            <ul>
              <li>
                <a href={mailtoHref()} className={styles.link}>
                  {site.email}
                </a>
              </li>
              <li>
                <a
                  href={site.social.instagram}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @{site.social.instagramHandle}
                </a>
              </li>
              <li>
                <a
                  href={site.social.instagramCoach}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @deepak.r2p
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.bottom}>
          <p>
            © {year} {site.name}. All rights reserved.
          </p>
        
        </div>
      </Container>
    </footer>
  );
}
